import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/admin/customer`, { params: params });
	},
	download(payload) {
		return Repository.post(`/company/${company.value.id}/admin/customer/download`, payload, { responseType: 'blob' });
	},
	birthdays() {
		return Repository.get(`/company/${company.value.id}/admin/customer/birthdays`);
	},
	import(payload) {
		return Repository.post(`/company/${company.value.id}/admin/customer/import`, payload).then((response) => {
			toast.success(`Clientes importados correctamente.`);
			return response;
		});
	},
	group(payload) {
		return Repository.put(`/company/${company.value.id}/admin/customer/group`, payload).then((response) => {
			toast.success(`Clientes agrupados correctamente.`);
			return response;
		});
	},
	ungroup(payload) {
		return Repository.put(`/company/${company.value.id}/admin/customer/ungroup`, payload).then((response) => {
			toast.success(`Clientes desagrupados correctamente.`);
			return response;
		});
	},
	show(id) {
		return Repository.get(`/company/${company.value.id}/admin/customer/${id}`);
	}
}